module.exports = __webpack_public_path__ + "static/media/desktopScreenshot08.d263f1f2.jpg";